import { render } from "./LinkComponent.vue?vue&type=template&id=71bbf570&scoped=true&ts=true"
import script from "./LinkComponent.vue?vue&type=script&lang=ts"
export * from "./LinkComponent.vue?vue&type=script&lang=ts"

import "./LinkComponent.vue?vue&type=style&index=0&id=71bbf570&scoped=true&lang=scss"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71bbf570"]])

export default __exports__